import { Component, OnInit } from '@angular/core';
import { LibraryService, Dropobj } from '../services/library.service';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';

export interface modelsource {
  srcid: number;
  srcnm: string;
  status: boolean;}
@Component({
  selector: 'app-libmaster',
  templateUrl: './libmasters.component.html',
  styleUrls: ['./libmasters.component.scss'],
  providers:[LibraryService]
})
export class LibmasterComponent implements OnInit {
    depts:any[];
    boolenable:Boolean=true;
    catgories:any[];
    suppliers:any[];
    publishers:any[];
    sources:modelsource[];
    subjects:any[];
    author: Dropobj[];
    statuses: any[];
    acctypes: any[];
    subgroup:any[];
    settings:any[];
    genheaders:any[];
    arracctype:any[];
    actypemodel:any={};
    arbksections:any[];
    categorymodel:any={};
    sourcemodel:any={};
    deptmodel:any={};
    pubmodel:any={};
    supmodel:any={};
    submodel:any={};
    setmodel:any={};
    genmodel:any={};
    arridcardsetting:any=[];
    objbksection:any={};
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  arrmemtype=[{value:'student',label:'Student'},{value:'staff',label:'Staff'}];
  arrpubtype=[{value:'Both',label:'Both'},{value:'Book',label:'Book'},{value:'Periodical',label:'Periodical'}];

  constructor(private liservice: LibraryService,private modalService: NgbModal) { 


  }

  ngOnInit(): void {
    this.getlibcategory();
    this.getlibsource();
    this.getlibdepartment();
    this.getslibmbksection();
    this.getlibsubgroup();
    this.getlibaccesiontype();
    this.getidcardsettings();
    
  }

  
  opencategory(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.categorymodel={};
      this.categorymodel.bkcatid=0;
      this.categorymodel.oprtype='insert';
      this.categorymodel.status=true;

    }

    else if(cmd=='update')
    {
      this.categorymodel=objdata;
      this.categorymodel.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  onchangeidcard(e,obj)
  {
    console.log(e.checked);
    var pst={type:obj.type,status:e.checked};

    this.liservice.changeidcardsetting(pst)
        .subscribe(
        result => {
            console.log('savelibcategory', result);
            //this.suppliers = resultArray;
           this.getidcardsettings();
        },
        error =>{ alert('Error While saving...');}
        )
  }
  SavecatDetails()
  {
console.log('catsave',this.categorymodel);
    this.liservice.savelibcategory(this.categorymodel)
        .subscribe(
        result => {
            console.log('savelibcategory', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getlibcategory();

            }
           else
           {

           }
        },
        error =>{ alert('Error While saving...');}
        )
  }

  

  opensource(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.sourcemodel={};
      this.sourcemodel.srcid=0;
      this.sourcemodel.oprtype='insert';
      this.sourcemodel.status=true;

    }

    else if(cmd=='update')
    {
      this.sourcemodel=objdata;
      this.sourcemodel.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  SavesourceDetails()
  {
console.log('catsave',this.sourcemodel);
    this.liservice.savelibsource(this.sourcemodel)
        .subscribe(
        result => {
            console.log('SavesourceDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getlibsource();
            }
         else  {

           }
        },
        error =>{ alert('Error While saving...');}
        )
  }

  onchangesource(e)
  {
    console.log('change',e);
    console.log('change',this.sources);
  }
  opendepartment(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.deptmodel={};
      
      this.deptmodel.bkdepid=0;
      this.deptmodel.oprtype='insert';
      this.deptmodel.status=true;

    }

    else if(cmd=='update')
    {
      this.deptmodel=objdata;
      this.deptmodel.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  SavedepartDetails()
  {
console.log('catsave',this.sourcemodel);
    this.liservice.savelibdepart(this.deptmodel)
        .subscribe(
        result => {
            console.log('SavedepartDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getlibdepartment();

            }
           else
           {

           }
        },
        error =>{ alert('Error While saving...');}
        )
  }

  onchangedepart(e,obj)
  {
    //console.log(e.checked);
    //console.log(obj);
    this.deptmodel=obj;
    this.deptmodel.status=e.checked;
    this.deptmodel.oprtype='updstatus';
    this.SavedepartDetails();
  }

  onchangecat(e,obj)
  {
    //console.log(e.checked);
    //console.log(obj);
    this.categorymodel=obj;
    this.categorymodel.status=e.checked;
    this.categorymodel.oprtype='updstatus';
    this.SavecatDetails();
  }

  onchangesorce(e,obj)
  {
    //console.log(e.checked);
    //console.log(obj);
    this.sourcemodel=obj;
    this.sourcemodel.status=e.checked;
    this.sourcemodel.oprtype='updstatus';
    this.SavesourceDetails();
  }
  onchangepub(e,obj)
  {
    //console.log(e.checked);
    //console.log(obj);
    this.pubmodel=obj;
    this.pubmodel.status=e.checked;
    this.pubmodel.oprtype='updstatus';
    this.SavepubtDetails();
  }

  onchangesup(e,obj)
  {
    //console.log(e.checked);
    //console.log(obj);
    this.supmodel=obj;
    this.supmodel.status=e.checked;
    this.supmodel.oprtype='updstatus';
    this.SavesuppliertDetails();
  }

  onchangeset(e,obj)
  {
    //console.log(e.checked);
    //console.log(obj);
    this.setmodel=obj;
    this.setmodel.status=e.checked;
    this.setmodel.oprtype='updstatus';
    this.savesettings();
  }
  onchangesub(e,obj)
  {
    //console.log(e.checked);
    //console.log(obj);
    this.submodel=obj;
    this.submodel.status=e.checked;
    this.submodel.oprtype='updstatus';
    this.SavesubjectDetails();
  }
  openpublisher(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.pubmodel={};
      this.pubmodel.pubid=0;
      //this.submodel.parentsubid=0;
      this.pubmodel.oprtype='insert';
      this.pubmodel.status=true;
      this.pubmodel.state='';
      this.pubmodel.website='';
      this.pubmodel.phoneno='';
      this.pubmodel.fax='';
      this.pubmodel.email='';
      this.pubmodel.city='';
      this.pubmodel.addess='';
      this.pubmodel.pubtype='Both';
    

    }

    else if(cmd=='update')
    {
      this.pubmodel=objdata;
      this.pubmodel.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  
  SavepubtDetails()
  {
console.log('catsave',this.sourcemodel);
    this.liservice.savelibpublisher(this.pubmodel)
        .subscribe(
        result => {
            console.log('SavepubtDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getlibpublisher();

            }
           else
           {

           }
        },
        error =>{ alert('Error While saving...');}
        )
  }


  opensupplier(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.supmodel={};
      this.supmodel.supid=0;
      //this.submodel.parentsubid=0;
      this.supmodel.oprtype='insert';
      this.supmodel.status=true;
      this.supmodel.state='';
      this.supmodel.street2='';
      this.supmodel.phoneno='';
      this.supmodel.street1='';
      this.supmodel.email='';
      this.supmodel.city='';
      this.supmodel.suptype='Both';
      

    }

    else if(cmd=='update')
    {
      this.supmodel=objdata;
      this.supmodel.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  
  opensubject(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.submodel={};
     
      
      this.submodel.subid=0;
      this.submodel.parentsubid=0;
      this.submodel.oprtype='insert';
      this.submodel.status=true;

    }

    else if(cmd=='update')
    {
      this.submodel=objdata;
      this.submodel.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  
  SavesubjectDetails()
  {
console.log('catsave',this.submodel);
    this.liservice.savelibsubjects(this.submodel)
        .subscribe(
        result => {
            console.log('SavesubjectDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getlibsubjects();

            }
           else
           {

           }
        },
        error =>{ alert('Error While saving...');}
        )
  }
  SavesuppliertDetails()
  {
console.log('catsave',this.sourcemodel);
    this.liservice.savelibsupplier(this.supmodel)
        .subscribe(
        result => {
            console.log('SavepubtDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getlibsupplier();

            }
           else
           {

           }
        },
        error =>{ alert('Error While saving...');}
        )
  }


  savesettings()
  {
console.log('catsave',this.setmodel);
    this.liservice.savesettings(this.setmodel)
        .subscribe(
        result => {
            console.log('SavepubtDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getlibsettings();

            }
           else
           {

           }
        },
        error =>{ alert('Error While saving...');}
        )
  }

  opensettings(content,objdata,cmd) {
    
    if(cmd=='insert')
    {
      this.setmodel={};
     
      this.boolenable=true;
      this.setmodel.subid=0;
      this.setmodel.bkcatid='1';
      this.setmodel.id=0;
       this.setmodel.nod=0;
      this.setmodel.fineperday=0;
      this.setmodel.oprtype='insert';
      this.setmodel.status=true;
      this.setmodel.memtype='Student';
      this.setmodel.issuelimit=0;

    }

    else if(cmd=='update')
    {

      this.boolenable=false;
      this.setmodel=objdata;
      this.setmodel.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  

   catFilter( filters) {
    this.catgories=this.catgories.filter(o =>
        Object.keys(filters).every(k =>
            [].concat(filters[k]).some(v => o[k].includes(v))));
}


opengenmaster(content,objdata,cmd) {
  if(cmd=='insert')
  {
    this.genmodel={};
   
    
    
    this.genmodel.id=0;
     this.genmodel.name='';
    this.genmodel.mastypenm='Currency';
    this.genmodel.oprtype='insert';
   
  }

  else if(cmd=='update')
  {
    this.genmodel=objdata;
    this.genmodel.oprtype='update';
  }
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


SavegenmasDetails()
{
console.log('catsave',this.genmodel);
  this.liservice.SavegenmasDetails(this.genmodel)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='Success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
            this.getlibmasgeneral();

          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
}
getlibmasgeneral() {
  this.liservice.getlibmasgeneral()
      .subscribe(
      resultArray => {
          console.log('getlibmasgeneral', resultArray);
         // resultArray.forEach(x => x.status = x.status === 'true');
          this.genheaders = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}

  getlibsupplier() {
    this.liservice.getlibsupplier()
        .subscribe(
        resultArray => {
            console.log('getlibsupplier', resultArray);
            resultArray.forEach(x => x.status = x.status === 'true');
            this.suppliers = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  getlibsubjects() {
    this.liservice.getlibsubjects()
        .subscribe(
        resultArray => {
            console.log('getlibsubjects', resultArray);
            resultArray.forEach(x => x.status = x.status === 'true');
            this.subjects = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  getlibcategory() {
    this.liservice.getlibcategory()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
            resultArray.forEach(x => x.status = x.status === 'true');
            this.catgories = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  getlibsource() {
    this.liservice.getlibsource()
        .subscribe(
        resultArray => {
            console.log('getlibsource', resultArray);
            resultArray.forEach(x => x.status = x.status === 'true');
           console.log('getlibsource1', resultArray);
            this.sources = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }
  getlibpublisher() {
    this.liservice.getlibpublisher("selall")
        .subscribe(
        resultArray => {
            console.log('getlibpublisher', resultArray);
            resultArray.forEach(x => x.status = x.status === 'true');
            this.publishers = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }
  getlibdepartment() {
    this.liservice.getlibdepartment()
        .subscribe(
        resultArray => {
            console.log('getlibdepartment', resultArray);
           // console.log('getlibdepartment1',JSON.parse( resultArray));
           resultArray.forEach(x => x.status = x.status === 'true');
            this.depts = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }

  getlibaccesiontype() {
    this.liservice.getlibaccesiontype()
        .subscribe(
        resultArray => {
            console.log('getlibaccesiontype', resultArray);
           // console.log('getlibdepartment1',JSON.parse( resultArray));
          // resultArray.forEach(x => x.status = x.status === 'true');
            this.arracctype = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }

  
  openaccntype(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.actypemodel={};
      
      this.actypemodel.acsid=0;
      this.actypemodel.oprtype='insert';
      //this.objbksection.status=true;

    }

    else if(cmd=='update')
    {
      this.actypemodel=objdata;
      this.actypemodel.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  saveaccntype()
  {
console.log('catsave',this.actypemodel);
    this.liservice.savelibaccesiontype(this.actypemodel)
        .subscribe(
        result => {
            console.log('savelibaccesiontype', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getlibaccesiontype();

            }
           else
           {

           }
        },
        error =>{ alert('Error While saving...');}
        )
  }


  getslibmbksection() {
    this.liservice.getslibmbksection()
        .subscribe(
        resultArray => {
            console.log('getlibdepartment', resultArray);
           // console.log('getlibdepartment1',JSON.parse( resultArray));
           resultArray.forEach(x => x.status = x.status === 'true');
            this.arbksections = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }

  onchangebksection(e,obj)
  {
    //console.log(e.checked);
    //console.log(obj);
    this.objbksection=obj;
    this.objbksection.status=e.checked;
    this.objbksection.oprtype='updstatus';
    this.savelibmbksection();
  }


  savelibmbksection()
  {
console.log('catsave',this.objbksection);
    this.liservice.savelibmbksection(this.objbksection)
        .subscribe(
        result => {
            console.log('savelibmbksection', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getslibmbksection();

            }
           else
           {

           }
        },
        error =>{ alert('Error While saving...');}
        )
  }

  openbksection(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.objbksection={};
      
      this.objbksection.bksecid=0;
      this.objbksection.oprtype='insert';
      this.objbksection.status=true;

    }

    else if(cmd=='update')
    {
      this.objbksection=objdata;
      this.objbksection.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  getlibsubgroup() {
    this.liservice.getlibsubjectgroup()
        .subscribe(
        resultArray => {
            console.log('getlibsubjectgroup', resultArray);
            this.subgroup = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }
  getlibsettings() {
    this.liservice.getlibsettings()
        .subscribe(
        resultArray => {
            console.log('getlibsettings', resultArray);
            this.settings = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }


  getidcardsettings() {
    this.liservice.getidcardsetting()
        .subscribe(
        resultArray => {
            console.log('getlibsource', resultArray);
            resultArray.forEach(x => x.status = x.status === 'true');
           console.log('getidcardsetting', resultArray);
            this.arridcardsetting = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }
}
